<script>
import { layoutComputed, authComputed, authMethods } from '@state/helpers'
import Vertical from '@router/layouts/vertical'
import Horizontal from '@router/layouts/horizontal'

export default {
  components: { Vertical, Horizontal },
  data() {
    return {
      isValid : false,
      passwordMin : false,
      password : '',
      confirmPassword : '',
    }
  },
  computed: {
    ...layoutComputed,
    ...authComputed,
  },
  watch : {
      password: {
          handler: function (newVal, oldval) {
            this.checkValid();
            if (this.password.length < 3) {
              this.passwordMin = true;
            } else {
              this.passwordMin = false;
            }
          },
      },
      confirmPassword: {
          handler: function (newVal, oldval) {
              this.checkValid();
          },
      },
  },
  methods: {
    ...authMethods,
    checkValid(){
      if (this.password !== this.confirmPassword) {
        this.isValid = false
      } else {
        this.isValid = true
      }
    },
    gantiPassword(){
      this.changePassword({password: this.password, confirmPassword : this.confirmPassword})
      .then((response) => {
        console.log(response)
        if (response.data) {
          this.toast('b-toaster-bottom-right', true, "Password Berhasil Diupdate")
        } else {
          this.toast('b-toaster-bottom-right', false, "Password Gagal Diupdate")
        }
        this.awal()
      })
    },
    toast(toaster, append = false, body) {
      this.$bvToast.toast(body, {
          title: "Ubah Password",
          toaster: toaster,
          solid: true,
          appendToast: append,
          variant : 'success'
      })
    },
    awal(){
      this.isValid = false;
      this.passwordMin = false;
      this.password = '';
      this.confirmPassword = '';
      this.showModalPassword({modalPassword : false})
    }
  },
}
</script>

<template>
  <div>
    <Vertical v-if="layoutType === 'vertical'" :layout="layoutType">
      <slot />
    </Vertical>

    <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
      <slot />
    </Horizontal>

    <b-modal v-model="modalPassword"  title-class="text-center" centered hide-header hide-footer no-close-on-backdrop>
      <div>
        <b-form-group
          id="input-group-1"
          label="Password Baru"
          label-for="password"
        >
          <b-form-input
            id="password"
            v-model="password"
            type="password"
            required
            placeholder="Masukkan Password"
          ></b-form-input>
          <span v-if="passwordMin && password !== ''" class="text-danger font-size-11">password minimal 3 karakter</span>
        </b-form-group>
        <b-form-group
          id="input-group-2"
          label="Konfirmasi Password"
          label-for="confirmPassword"
        >
          <b-form-input
            id="confirmPassword"
            v-model="confirmPassword"
            type="password"
            required
            placeholder="Konfirmasi Password"
            :disabled="passwordMin"
          ></b-form-input>
        </b-form-group>
      </div>
      <p v-if="!isValid && password !== '' && confirmPassword !== ''" class="text-danger font-size-13">konfirmasi password tidak sama</p>
       <div class="text-right">
          <b-button class="mr-2" type="button" variant="outline-primary" @click="awal">Batal / Keluar</b-button>
          <b-button type="button" variant="primary" :disabled="!isValid" @click="gantiPassword">Simpan Perubahan</b-button>
       </div>
    </b-modal>
  </div>
</template>
